import React, { Fragment, useState , useEffect, Share } from 'react';
import Formulario from './formulario';
import Datospaciente from './pacientes';
import Datosordenes from './ordenespaciente';

import axios from 'axios';


const Busqueda = () => {
 //definer el state 

 const [busquedaOrden, guardarBusquedaOrden] = useState ({});
 const [pacientes, guardarPaciente]= useState([]);
 const [idordenpaciente, guardarOrdenPaciente]= useState([]);
 const [idpacientes, setPacientes]= useState([]);



 useEffect(() => {
  if(Object.keys(busquedaOrden).length=== 0 )  return;

   const  consultarPacientess  =  async () =>{ 
     const { paciente=[],numorden=[] } = busquedaOrden;
   
       
     //CONSULTA DE PACIENTE

           const requestOptions = {
                  method: 'POST',
                  headers: { 
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin':'*'
                           },
                     
                 
                  body: JSON.stringify({ tipoIdentificacion : "DNI",
                                        numeroIdentificacion : paciente,
                                        numeroOrden: numorden })
              };
              
           const peticion =  await fetch(`https://cebacapi.herokuapp.com/Service.svc/paciente.json`,  requestOptions)
           .then(res => { 
              res.json().then(data =>{
                console.log(data);  
                guardarPaciente(data.paciente);
             })
                
           })
           .catch(console.warn);

   }
    consultarPacientess();
 },[busquedaOrden]) 

useEffect(() => {
  if(Object.keys(pacientes).length=== 0 )  return;

   const  consultarOrdeness  =  async () =>{ 
     const { id=[] } = pacientes;
   
   /// pediodo orden por paciente
           

            const requestOptionsOrden = {
            method: 'POST',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin':'*'
                     },
               
           
            body: JSON.stringify({ 
                                  idPaciente :id
                               })
        };
        
     const peticion1 =  await fetch(`https://cebacapi.herokuapp.com/Service.svc/ordenes.json`,  requestOptionsOrden)
       .then(res => { 
              res.json().then(data =>{
                console.log(data);  
                guardarOrdenPaciente(data.ordenes);
                
              })
                
           })
           .catch(console.warn);
   }
    consultarOrdeness();
 },[pacientes])        


function refreshPage(){ window.location.reload(); } 


return (
   
   <Fragment>
   
     <Formulario
            guardarBusquedaOrden={guardarBusquedaOrden}
     />
   
     <div className="container">
        <div className="row">
            <div className="col-md-5">

               <Datospaciente 
                 paciente={pacientes}
               />
            </div>
      </div>
        <table className = "table table-hover" >
                {idordenpaciente.length ===0  ? null :  
                <tr>    
                   <td width="80" scope="col"><b>N° Orden</b></td> 
                   <td width="80" scope="col"><b>Fecha Pedido</b></td>  
                   <td width="80" scope="col"><b>Fecha Entrega </b></td>  
                   <td width="80" scope="col"><b>Resultados</b></td>
                </tr>
                 }
           {idordenpaciente.length ===0  ? null :  
             idordenpaciente.map((idorndennnn) => (
                  <Datosordenes 

                   key={idorndennnn.id}
                   idordenpaciente={idorndennnn}
                 />
              ))
             
              }
          </table>      
                
           </div>
   
         
   </Fragment>
   
 );
     
}


export default Busqueda;

